import { render, staticRenderFns } from "./liveCallMod.vue?vue&type=template&id=4da5db58&"
import script from "./liveCallMod.vue?vue&type=script&lang=js&"
export * from "./liveCallMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "liveCallMod.vue"
export default component.exports